import React from 'react';

const AdminSubIndustriesHeader = ({
  loading,
  total,
  industryName,
  onBackToIndustries,
  onBackToAdmin,
}) => (
  <div className="mb-8">
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          Manage Sub-Industries
          {industryName &&
            industryName !== 'All Industries' && (
              <span className="text-emerald-600 dark:text-emerald-400">
                {' '}
                - {industryName}
              </span>
            )}
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {loading ? 'Loading...' : `Total: ${total} sub-industries`}
        </p>
      </div>
      <div className="flex space-x-3">
        <button
          type="button"
          onClick={onBackToIndustries}
          className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700"
        >
          ← Back to Industries
        </button>
        <button
          type="button"
          onClick={onBackToAdmin}
          className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700"
        >
          Admin Dashboard
        </button>
      </div>
    </div>
  </div>
);

export default AdminSubIndustriesHeader;


